// Midnight lore lines used for the atmospheric footer whispers.
// Extend this list to add more flavor without touching the footer component.
export const MIDNIGHT_LORE_LINES: string[] = [
  'shhh… nothing ever happened.',
  'Midnight traffic leaves no footprints, only ripples.',
  'system extrinsics hum in the dark, user activity flickers on top.',
  'you are watching block time in slow motion.',
  'the chain is quiet… for now.',
  'some blocks carry secrets, some carry only plumbing.',
  'midnight never sleeps; it just gets quieter.'
];
